import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './DashboardHero.css';

const DashboardHero = () => {
    const { currentUser } = useAuth();
    const displayName = currentUser?.displayName || currentUser?.email?.split('@')[0] || 'there';
    const [greeting, setGreeting] = useState('');

    useEffect(() => {
        const hour = new Date().getHours();
        if (hour < 12) setGreeting('Good morning');
        else if (hour < 17) setGreeting('Good afternoon');
        else setGreeting('Good evening');
    }, []);

    return (
        <section className="dashboard-hero">
            <div className="container">
                <div className="hero-welcome">
                    <p className="hero-greeting">{greeting},</p>
                    <h1><span className="gradient-text">{displayName}</span></h1>
                    <p className="hero-subtitle">Here's your business at a glance today</p>
                </div>
            </div>
            <div className="hero-wave">
                <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
                    <path d="M0 40C240 80 480 0 720 40C960 80 1200 0 1440 40V80H0V40Z" fill="var(--neutral-50)" />
                </svg>
            </div>
        </section>
    );
};

export default DashboardHero;
